export default {
  getGlobalSettings: {
    method: 'get',
    url: '/client/settings'
  },
  updateGlobalSettings: {
    method: 'post',
    url: '/client/settings/update'
  },
  getGPSSettings: {
    method: 'get',
    url: '/client/settings/gps'
  },
  updateGPSSettings: {
    method: 'post',
    url: '/client/settings/gps'
  },
  updateConfigContSettings: {
    method: 'post',
    url: '/client/settings/config-cont/update'
  },
  updateTimesSettings: {
    method: 'put',
    url: '/client/settings/times'
  },
  updateCostSettings: {
    method: 'put',
    url: '/client/settings/cost'
  },
  updatePartnerSettings: {
    method: 'put',
    url: '/client/settings/partner'
  },
  updatePolicySettings: {
    method: 'put',
    url: '/client/settings/policy'
  },
  uploadCompanyLogo: {
    method: 'post',
    url: '/client/settings/upload-company-logo'
  },
  updateRouteSettings: {
    method: 'put',
    url: '/client/settings/route'
  }
}
